import { getDay, getDaysInMonth, startOfMonth } from "date-fns";
import { IDate } from "shared/types";

export const getMonthInfo = (date: IDate) => {
  const day = new Date(date.year, date.month);
  let monthStartsOn = getDay(startOfMonth(day)) as number;
  monthStartsOn = monthStartsOn === 0 ? 6 : monthStartsOn - 1;
  const daysInMonth = getDaysInMonth(day);

  return { monthStartsOn, daysInMonth };
};
